<template>
  <v-container fluid grid-list-md style="padding: 20px;">
    <v-row dense v-if="user.tipo == 'ADMIN'">
      <v-col cols="12" sm="12" md="6">
        <v-select
          outlined
          dense
          v-model="empresaSelecionada"
          :items="empresas"
          item-text="nome"
          item-value="id"
          label="Selecione a empresa"
          @input="carregaTemplatesMeta(user.tipo == 'ADMIN' ? empresaSelecionada : user.empresaId);"
        ></v-select>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="12" md="12">
        <v-data-table
          :search="tabela.busca"
          :headers="tabela.cabecalho"
          :items="tabela.conteudo"
          sort-by="titulo"
          class="elevation-1"
          style="border-radius: 10px;"
          :footer-props="{
            'items-per-page-text': 'Linhas por página',
            'items-per-page-all-text': 'Tudo',
          }"
          :loading="tabela.carregamento"
          loading-text="Buscando itens..."
        >
          <template v-slot:top>
            <v-toolbar flat color="white" style="border-radius: 10px;">
              <v-toolbar-title class="textoUser">TEMPLATES META</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-text-field v-model="tabela.busca" append-icon="search" label="Procurar" single-line hide-details></v-text-field>
              <v-spacer></v-spacer>
              <v-btn text @click="dialogoTemplate = true" tile color="#3BA8A2" :disabled="user.tipo == 'ADMIN' ? !empresaSelecionada : false">
                <v-icon left dark>add_circle</v-icon>Cadastrar
              </v-btn>
            </v-toolbar>
          </template>
          <template v-slot:[`item.action`]="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on">
                  <v-icon @click="editItem(item)" color="#01579B">mdi-pencil</v-icon>
                </v-btn>
              </template>
              <span>Editar</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on">
                  <v-icon @click="deleteItem(item)" color="#FF0000">mdi-delete</v-icon>
                </v-btn>
              </template>
              <span>Excluir</span>
            </v-tooltip>
          </template>
          <template v-slot:[`item.ativo`]="{ item }">
            <v-icon :color="item.ativo == true ? 'green' : 'red'">mdi-circle</v-icon>
          </template>
          <template v-slot:[`item.tipoMensagem`]="{ item }">
            <td>{{ retornaTipoMensagem(item.tipoMensagem) }}</td>
          </template>
          <template v-slot:no-data>
            <v-row>
              <v-col>
                <v-alert dark dense text outlined color="warning" icon="info" style="margin: 0px">Nenhum template cadastrado</v-alert>
              </v-col>
            </v-row>
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <v-dialog v-model="dialogoTemplate" persistent max-width="500px" scrollable>
      <v-card>
        <v-card-title>{{ formTitle }}</v-card-title>
        <v-card-subtitle>* indica preenchimento obrigatório</v-card-subtitle>
        <v-card-text style="padding: 10px 25px 0px 25px">
          <v-row>
            <v-col cols="12" xs="12" sm="12" md="12" lg="12" id="selectTemplate">
              <v-select
                label="Template*"
                outlined
                dense
                hide-details
                v-model="templateSelecionado"
                :items="templates"
                item-text="name"
                item-value="name"
                return-object
                @change="selecionaTemplate"
              >
                <template v-slot:item="{ item }">
                  <v-list-item-content>
                    <v-list-item-title>{{ item.name }}</v-list-item-title>
                    <v-list-item-subtitle>{{ item.category }}</v-list-item-subtitle>
                  </v-list-item-content>
                </template>
              </v-select>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="12" lg="12">
              <v-select
                label="Tipo de Mensagem*"
                outlined
                dense
                hide-details
                v-model="editedItem.tipoMensagem"
                :items="tiposMensagem"
                item-text="text"
                item-value="value"
              ></v-select>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="12" lg="12">
              <v-switch
                :label="editedItem.ativo ? 'Template Ativo' : 'Template Inativo'"
                v-model="editedItem.ativo"
                inset
                style="margin: 0px;"
                hide-details
              ></v-switch>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="error" @click="dialogoTemplate = false">Fechar</v-btn>
          <v-btn text color="success" @click="salvarTemplate" v-if="editedIndex == -1">Salvar</v-btn>
          <v-btn text color="success" @click="editarTemplate" v-if="editedIndex != -1">Salvar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <Snackbar ref=chamaSnackbar />
    <loading :active.sync="isLoading" :can-cancel="true" color="#3BA8A2" :is-full-page="fullPage"></loading>
  </v-container>
</template>

<script>
  // Import component
  import Loading from 'vue-loading-overlay';
  // Import stylesheet
  import 'vue-loading-overlay/dist/vue-loading.css';
  import { baseApiUrl } from '@/global'
  import Snackbar from '../componentes/snackbar.vue'
  import axios from 'axios'
  import { mapState } from 'vuex'
  // import moment from 'moment'
  export default {
    components: { Snackbar, Loading, },
    data: () => ({
      isLoading: false,
      fullPage: true,
      lojistas: [],
      tabela: {
        busca: '',
        cabecalho: [
          { text: 'Template', align: 'start', value: 'templateNome', },
          { text: 'Tipo de Mensagem', value: 'tipoMensagem' },
          { text: 'Ativo', value: 'ativo' },
          { text: 'Ações', value: 'action', sortable: false, align: 'center' },
        ],
        carregamento: false,
        conteudo: [],
      },
      dialogoTemplate: false,
      editedIndex: -1,
      editedItem: {
        empresaId: '',
        tipoMensagem: '',
        templateNome: '',
        metaTemplateName: '',
        metaTemplateLanguage: '',
        ativo: true,
      },
      defaultItem: {
        empresaId: '',
        tipoMensagem: '',
        templateNome: '',
        metaTemplateName: '',
        metaTemplateLanguage: '',
        ativo: true,
      },
      exibirQRCode: false,
      gatewayPagamento: '',
      saldoCartao: '',
      valorTransacao: 0.00,
      tipoTransacao: '',
      formaTransacao: '',
      codigoQrCode: '',
      empresas: [],
      empresaSelecionada: '',
      templates: [],
      templateSelecionado: null,
      tiposMensagem: [
        { text: 'Boas vindas', value: 'BOAS VINDAS' },
        { text: 'Consumo', value: 'CONSUMO' },
        { text: 'Depósito', value: 'DEPÓSITO' },
        { text: 'Estorno', value: 'ESTORNO' },
        { text: 'Novo pedido', value: 'NOVO PEDIDO' },
        { text: 'Recuperar senha', value: 'RECUPERAR SENHA' },
        // { text: 'Solicitar resgate', value: 'SOLICITAR RESGATE' },
        // { text: 'Resgate concluído', value: 'RESGATE CONCLUÍDO' },
        { text: 'Saque', value: 'SAQUE' },
      ],
    }),

    computed: mapState({
      ConsumidorLogado: state => state.isMenuVisible,
      user: state => state.userObj,
      companyobj: state => state.companyObj,
      formTitle () {
        return this.editedIndex === -1 ? 'Cadastrar template' : 'Editar template'
      },
    }),

    watch: {
      dialogoTemplate(val) {
        if (val == false) {
          setTimeout(() => {
            this.editedItem = Object.assign({}, this.defaultItem)
            this.editedIndex = -1
            this.templateSelecionado = null
          }, 300);
        }
      },
    },

    mounted() {
      if (this.user.tipo == 'ADMIN') {
        this.carregaEmpresas()
      } else {
        this.carregaTemplatesMeta()
      }
    },

    methods: {
      async carregaEmpresas() {
        await axios.get(baseApiUrl + 'Empresas?filter={"where":{"apiWhatsApp":"META"}, "order":"nome ASC", "fields":{"nome": true, "id": true}}&access_token=' + sessionStorage.getItem('accToken'))
        .then(response => {
          if (response.data.length > 0) {
            this.empresas = response.data
          }
        })
      },

      async carregaTemplatesMeta (empresaId) {
        this.tabela.conteudo = []
        this.isLoading = true
        this.tabela.carregamento = true

        await axios.get(baseApiUrl + 'TemplateMensagens?filter={"where":{"empresaId":"' + empresaId + '"}}&access_token=' + sessionStorage.getItem('accToken'))
        .then(response => {
          if (response.data) {
            this.consultarTemplates(empresaId)
            this.tabela.conteudo = response.data
            this.tabela.carregamento = false
          }

          this.isLoading = false
        })
      },

      editItem (item) {
        this.isLoading = true
        this.editedIndex = this.tabela.conteudo.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.templateSelecionado = this.templates.find(template => template.name == item.templateNome)
        this.dialogoTemplate = true
        this.isLoading = false
      },

      async salvarTemplate() {
        var vm = this;

        if (this.editedItem.tipoTransacao || this.editedItem.metaTemplateName || this.editedItem.templateNome) {
          this.isLoading = true
          this.editedItem.empresaId = this.user.tipo == 'ADMIN' ? this.empresaSelecionada : this.companyobj.id

          await axios.post(baseApiUrl + 'TemplateMensagens?access_token=' + sessionStorage.getItem('accToken'), this.editedItem)
          .then(response => {
            if (response.data) {
              this.isLoading = false
              this.dialogoTemplate = false
              vm.$refs.chamaSnackbar.snack("green", "Operação realizada com sucesso!", "INFORMAÇÃO")
              this.carregaTemplatesMeta(this.user.tipo == 'ADMIN' ? this.empresaSelecionada : this.companyobj.id)
            }
          })
          .catch(() => {
            vm.$refs.chamaSnackbar.snack("red", "Erro ao realizar operação", "DESCULPE")
          })
        }
        else {
          vm.$refs.chamaSnackbar.snack("orange", "Preencha os campos para prosseguir", "ATENÇÃO")
        }
      },

      async editarTemplate() {
        var vm = this;

        if (this.editedItem.tipoTransacao || this.editedItem.metaTemplateName || this.editedItem.templateNome) {
          this.isLoading = true

          await axios.post(baseApiUrl + 'TemplateMensagens?access_token=' + sessionStorage.getItem('accToken'), this.editedItem)
          .then(response => {
            if (response.data) {
              this.isLoading = false
              this.dialogoTemplate = false
              vm.$refs.chamaSnackbar.snack("green", "Operação realizada com sucesso!", "INFORMAÇÃO")
              this.carregaTemplatesMeta(this.user.tipo == 'ADMIN' ? this.empresaSelecionada : this.companyobj.id)
            }
          })
          .catch(() => {
            vm.$refs.chamaSnackbar.snack("red", "Erro ao realizar operação", "DESCULPE")
          })
        }
        else {
          vm.$refs.chamaSnackbar.snack("orange", "Preencha os campos para prosseguir", "ATENÇÃO")
        }
      },

      async deleteItem(item) {
        var vm = this;
        var r = confirm('Deseja realmente excluir o template ' + item.templateNome + '?');

        if (r == true) {
          this.isLoading = true;
          await axios.delete(baseApiUrl + 'TemplateMensagens/' + item.id + '?access_token=' + sessionStorage.getItem('accToken'))
          .then(() => {
            this.isLoading = false;
            vm.$refs.chamaSnackbar.snack('success', 'Template excluído com sucesso!', 'INFORMAÇÃO');
            this.carregaTemplatesMeta(this.user.tipo == 'ADMIN' ? this.empresaSelecionada : this.companyobj.id);
          })
          .catch(() => {
            this.isLoading = false;
            vm.$refs.chamaSnackbar.snack('red', 'Erro ao excluir template', 'DESCULPE');
          });
        }
      },

      async consultarTemplates(empresaId) {
        await axios.post(baseApiUrl + 'ServiceMeta/templates?access_token=' + sessionStorage.getItem('accToken'), {"empresaId": empresaId})
        .then(response => {
          if (response.data) {
            this.templates = response.data
          }
        })
        .catch(() => {
          this.$refs.chamaSnackbar.snack("red", "Erro ao consultar templates", "DESCULPE")
        })
      },

      selecionaTemplate(item) {
        this.editedItem.metaTemplateName = item.name
        this.editedItem.templateNome = item.name
        this.editedItem.metaTemplateLanguage = item.language
        this.editedItem.metaComponents = item.components
      },

      retornaTipoMensagem(tipo) {
        let texto = ''

        for (let i = 0; i < this.tiposMensagem.length; i++) {
          if (this.tiposMensagem[i].value === tipo) {
            texto = this.tiposMensagem[i].text
            break
          }
        }

        return texto
      },
    },
  }
</script>

<style>
  .textoUser {
    font-weight: bold;
    color: #424f4e;
    font-size: 17px;
  }

  @font-face {
    font-family: Roboto;
    src: url('https://fonts.google.com/specimen/Roboto');
  }

  .cssBotao {
    font-weight: bold;
    border-radius: 8px; width: 150px;
    font-size: 7px;
  }

  .theme--light.v-data-table thead tr th {
    color: white;
  }

  span.v-stepper__step__step.primary {
    background-color: #009B99!important;
    border-color: #009b9b!important;
  }

  .theme--light.v-stepper .v-stepper__label {
    color: #009B99;
  }

  .theme--light.v-stepper .v-stepper__step--complete .v-stepper__label {
    color: #009B99;
  }

  .whatsapp-bubble {
    max-width: 80%;
    background-color: #e1ffc7; /* verde claro do WhatsApp */
    padding: 12px 16px;
    border-radius: 12px;
    border-top-left-radius: 0px; /* ponta do balão */
    font-size: 15px;
    line-height: 1.4;
    box-shadow: 0 1px 2px rgba(0,0,0,0.2);
    align-self: flex-start; /* fica alinhado à esquerda como mensagem recebida */
    position: relative;
  }

  /* Triângulo da pontinha do balão */
  .whatsapp-bubble::before {
    content: "";
    position: absolute;
    left: -8px;
    top: 0;
    width: 0;
    height: 0;
    border-right: 8px solid #e1ffc7;
    border-top: 8px solid transparent;
    border-bottom: 8px solid transparent;
  }

  #selectTemplate .v-input__append-outer {
    margin-top: 0px;
  }
</style>
